import lazysizes from 'lazysizes';
import 'lazysizes/plugins/noscript/ls.noscript';
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
import LinkFocusHelper from './components/00_utilities/helpers/LinkFocusHelper';
import ScrollToHelper from './components/00_utilities/helpers/ScrollToHelper';
import YoutubeHelper from './components/00_utilities/helpers/YoutubeHelper';
import CookieHelper from './components/00_utilities/helpers/CookieHelper';
import GeneralHelper from './components/00_utilities/helpers/GeneralHelper';
import ChannelInfoHelper from './components/00_utilities/helpers/ChannelInfoHelper';

const componentHelper = new ComponentHelper();

/* eslint-disable */
const __svg__ = { path: './svg/*.svg', name: 'Icons/icons.svg', filename: svgFileName };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:8085/assets/';
}
/* eslint-enable */

// initialize for tracking
window.dataLayer = window.dataLayer || [];

/**
 * workaround for mobiles not respecting 100vh properly
 */
function setWindowInnerHeight() {
    document.body.style.setProperty('--window-inner-height', `${window.innerHeight}px`);

    window.addEventListener('resize', GeneralHelper.throttle(() => {
        document.body.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
    }, 200));
}

window.addEventListener('load', () => {
    window.youtubePlayers = [];
    window.lazysizes = lazysizes;

    setWindowInnerHeight();

    componentHelper.initializePage();
    LinkFocusHelper.handleHashLink();
    ScrollToHelper.initializeAnchorLinks(lazysizes);

    // initialize marketing cookie behaviour for Youtube and Google Maps
    const customEventsOnMarketingAccept = [
        'consent-type-youtube',
        'consent-type-google-maps',
        'consent-type-snap-engage',
        'consent-type-alveni',
    ];
    CookieHelper.addMarketingCookieListener(customEventsOnMarketingAccept);
    YoutubeHelper.addYoutubeConsentListener();
    ChannelInfoHelper.saveChannelInfo();
});

/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}
